import { type CountryCodeReader, type RegionalBaseUrls } from "../constants";
import { getRegion } from "../gatewayRegion";

const gatewayConfig: {
  urls: RegionalBaseUrls;
  readCountryCode: CountryCodeReader;
} = {
  urls: { IN: "", US: "", GCC: "" },
  readCountryCode: () => "",
};

export function configureGatewayBaseUrls(
  urls: RegionalBaseUrls,
  countryCodeReader: CountryCodeReader,
): void {
  gatewayConfig.urls = urls;
  gatewayConfig.readCountryCode = countryCodeReader;
}

export function getGatewayApiUrl(..._legacyArguments: unknown[]): string {
  const region = getRegion(gatewayConfig.readCountryCode());
  return gatewayConfig.urls[region] || gatewayConfig.urls.IN;
}
